export default __webpack_public_path__ + "static/media/flash.abb6a8bc.svg";